import { getBetSelectionList } from '@tickets/helpers';

export const copyEvents = async (ticket, boostedOddsGameIds) => {
  const selections = await getBetSelectionList(ticket);

  // Look up the ticket's per-selection flags by selection_id. Legs whose
  // `bet_builder_match_id` is set were saved as part of a bet builder card;
  // tag them with `isInternalBetBuilder: true` so the betslip reconstructs
  // the BB card on copy (combined odd, single-card UI, BB rules apply).
  const ticketSelectionsById = (ticket?.dataFromSwarm?.selection_list || []).reduce(
    (acc, sel) => {
      acc[sel.selection_id] = sel;
      return acc;
    },
    {}
  );

  return selections.reduce((acc, selection, ind) => {
    const ticketSel = ticketSelectionsById[selection.id];
    const isInternalBetBuilder = ticketSel?.bet_builder_match_id != null;

    const data = {
      ...acc,
      [selection.id]: {
        game: selection.game,
        market: selection.market,
        event: isInternalBetBuilder
          ? { ...selection, isInternalBetBuilder: true }
          : selection,
        isBanker: ticketSel?.is_banker,
        isBoosted: boostedOddsGameIds[selection.game.id]?.some((item) => item.Id === selection?.id),
      },
    };

    if ([31, 184].includes(selection.sport.id)) {
      data[selection.id] = {
        ...data[selection.id],
        game: {
          ...data[selection.id].game,
          regionId: selection.region.id,
          competitionId: selection.competition.id,
        },
        event: {
          ...data[selection.id].event,
          isRacingEvent: true,
          racingType: selection.sport.id,
          sp: !selection.price,
          eventOption: ind + 1,
          marketType: ticket.dataFromSwarm.type_id >= 40 && ticket.dataFromSwarm.type_id <= 42 ? 2 : 3,
        },
      };
    }

    return data;
  }, {});
};
